export default __webpack_public_path__ + "static/media/landing.232478e7.gif";